module.exports = __webpack_public_path__ + "static/media/scanIcon.b3c7db2b.png";